import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ComingSoonModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  description?: string;
  featureName?: string; // Optional feature name to customize the message
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({ 
  open, 
  onOpenChange,
  featureName,
  description
}) => {
  const isMobile = useIsMobile();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn(
        "sm:max-w-[450px]",
        isMobile && "h-auto p-4 flex flex-col"
      )}>
        <DialogHeader className={cn("sm:p-2", isMobile && "p-2")}>
          <DialogTitle className="text-xl font-semibold text-center">Feature Coming Soon</DialogTitle>
        </DialogHeader>
        
        <div className="text-center py-8">
          {/* Icon or illustration could be added here */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="64" 
            height="64" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="mx-auto mb-4 text-primary"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          
          <p className="text-lg font-medium">
            {featureName ? `${featureName} is coming soon!` : 'This feature is coming soon!'}
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            {description || 'We are working hard to bring this feature to you!'}
          </p>
        </div>
        
        <DialogFooter className={cn(
          "sm:px-6 sm:py-4",
          isMobile && "px-4 py-3"
        )}>
          <Button 
            onClick={() => onOpenChange(false)}
            className={cn(isMobile && "w-full")}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ComingSoonModal;
